<template>
  <ion-list v-if="resources != null">
    <ion-list-header>
      <p>{{ title }}</p>
    </ion-list-header>

    <ion-item
      v-for="item in resources.data"
      :key="item.id"
      :ref="`items-${item.id}`"
      class="hydrated link"
      v-show="eventVisibility(item.event_from_date, item.event_to_date)"
    >
      <ion-label @click="openPopover(item, $event)">
        <ion-text :color="colorName(item.event_type.color)">
          <h2>{{ item.name }}</h2>
        </ion-text>
        <p>{{ parseDate(item.event_from_date, item.event_to_date) }}</p>
        <h3 class="ion-text-wrap">{{ item.description }}</h3>
      </ion-label>
    </ion-item>
  </ion-list>
  <ion-list v-else>
    <ion-list-header>
      <p>No events found</p>
    </ion-list-header>
  </ion-list>
  <ion-modal
    :is-open="updateModalState"
    @didDismiss="setUpdateModalState(false)"
  >
    <base-modal title="Update event" @closeModal="setUpdateModalState(false)">
      <update-event
        @closeModal="setUpdateModalState(false)"
        :resource="resourceToUpdate"
      ></update-event>
    </base-modal>
  </ion-modal>

  <ion-popover
    :is-open="popoverState"
    :event="popoverEvent"
    @didDismiss="setPopoverState(false)"
  >
    <base-popover
      @closePopover="setPopoverState(false)"
      :title="'Session ' + selectedResource.name"
    >
      <ion-item button @click="setResourceToUpdate(selectedResource.id)"
        >Edit</ion-item
      >
      <ion-item
        button
        @click="
          confirmDelete({
            id: selectedResource.id,
            name: selectedResource.name,
          })
        "
        >Delete</ion-item
      >
    </base-popover>
  </ion-popover>
</template>
<script>
import BaseModal from "../../Base/BaseModal.vue";
import UpdateEvent from "../Calendar/UpdateEvent.vue";
import BasePopover from "../../Base/BasePopover.vue";
import {
  IonList,
  IonListHeader,
  IonLabel,
  IonItem,
  IonText,
  IonPopover,
  IonModal,
  alertController,
} from "@ionic/vue";

import moment from "moment";

export default {
  props: {
    resources: {
      type: Object,
      required: true,
    },
    filter_date: {
      required: true,
    },
  },

  components: {
    IonList,
    IonListHeader,
    IonLabel,
    IonItem,
    IonText,
    IonModal,
    BaseModal,
    IonPopover,
    BasePopover,
    UpdateEvent,
  },
  data() {
    return {
      popoverState: false,
      popoverEvent: null,
      selectedResource: null,

      updateModalState: false,
      resourceToUpdate: {
        id: null,
        name: null,
      },
      xhrError: {
        header: null,
        description: null,
      },
    };
  },

  computed: {
    title() {
      if (!this.filter_date) {
        return "All events";
      }

      return `Events for ${moment(this.filter_date).format("ll")}`;
    },
  },

  methods: {
    slide(id) {
      this.$refs[`items-${id}`].$el.open();
    },

    alerter(header, message, buttons = ["close"]) {
      const alert = alertController.create({
        header: header,
        message: message,
        buttons: buttons,
      });

      return alert;
    },

    setErrorResponse(error) {
      if (error.response) {
        this.xhrError.header = error.response.data.header;
        this.xhrError.message = error.response.data.message;
      } else if (error.request) {
        this.xhrError.header = error.message || error.request;
        this.xhrError.message = "Please check your connection and try again";
      } else {
        this.xhrError.header = error.message;
        this.xhrError.message = "Something went wrong. Try again later";
      }
    },

    async confirmDelete(resource) {
      this.setPopoverState(false);
      const header = "Delete event ?";
      const message = `Event "${resource.name}" will be deleted.`;
      const buttons = [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
        },
        {
          text: "Okay",
          handler: () => {
            this.delete(resource.id);
          },
        },
      ];
      const alertDialog = await this.alerter(header, message, buttons);

      alertDialog.present();
    },

    async delete(data) {
      try {
        await this.$store.dispatch("event/deleteResource", data);
      } catch (error) {
        this.setErrorResponse(error);
        const alertDialog = await this.alerter(
          this.xhrError.header,
          this.xhrError.message
        );
        alertDialog.present();
      }
    },

    setUpdateModalState(state) {
      this.updateModalState = state;
      if (state == false) {
        this.setPopoverState(false);
      }
    },

    setResourceToUpdate(id) {
      const resource = this.resources.data.find(
        (resource) => resource.id === id
      );
      this.resourceToUpdate = resource;
      this.setUpdateModalState(true);
    },

    parseDate(from, to) {
      const from_str = moment(from).format("ll");
      if (from === to) {
        return from_str;
      }
      const to_str = moment(to).format("ll");
      return `${from_str} to ${to_str}`;
    },

    colorName(name) {
      let color = null;
      switch (name) {
        case "yellow":
          color = "warning";
          break;
        case "red":
          color = "danger";
          break;
        case "green":
          color = "success";
          break;
        default:
          color = "primary";
      }

      return color;
    },

    eventVisibility(from, to) {
      if (!this.filter_date) {
        return true;
      }
      const isBetween = moment(this.filter_date).isBetween(
        from,
        to,
        undefined,
        "[]"
      );
      return isBetween;
    },

    openPopover(resource, ev) {
      this.popoverEvent = ev;
      this.setSelectedResource(resource);
      this.setPopoverState(true);
    },

    setPopoverState(state) {
      this.popoverState = state;
    },

    setSelectedResource(resource) {
      this.selectedResource = resource;
    },
  },
};
</script>
